import { cn } from "utils/cn";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
};

const CheckBox = ({ className, ...checkboxProps }: CheckboxProps) => {
  return (
    <input
      type="checkbox"
      className={cn(
        "w-[26px] h-[26px] accent-black focus:ring-0 focus:ring-offset-0 rounded-lg",
        className
      )}
      {...checkboxProps}
    />
  )
};

export default CheckBox;